import { PropertyAPI } from "../../axios";

export const actions = {
  //Stock
  GetStocks(context, data) {
    return PropertyAPI.get(`StockItem/Campus/${data}`);
  },
  GetSingleStock(context, data) {
    return PropertyAPI.get(`StockItem/${data}`);
  },
  UpdateStock(context, data) {
    return PropertyAPI.put(`StockItem/${data.id}`, data);
  },
  DeleteStock(context, data) {
    return PropertyAPI.delete(`StockItem/${data}`);
  },
  CreateStock(context, data) {
    return PropertyAPI.post(`StockItem/Create/${data.campusId}`, data);
  },
  CreateMultipleStock(context, data) {
    return PropertyAPI.post(`StockItem/Create/Multiple/${data.campusId}`, data);
  },
  GetAvailableStocks(context, data) {
    return PropertyAPI.get(`StockItem/Available/${data}`);
  },
  UploadStockTransaction(context, data) {
    return PropertyAPI.post(`StockItem/Create/WithTransactions/${data.campusId}`, data.uploadArray);
  },

  // Stock Transactions
  GetStockTransactions(context, data) {
    return PropertyAPI.get(`StockItemTransaction/Stock/${data}`);
  },
  GetAvailableStockTransactions(context, data) {
    return PropertyAPI.get(`StockItemTransaction/AvailableStock/${data}`);
  },
  GetChildStockTransactions(context, data) {
    return PropertyAPI.get(`StockItemTransaction/ChildTransactions/${data}`);
  }, 
  GetPendingStockTransaction(context, data) {
    return PropertyAPI.get(`StockItemTransaction/Pending/${data}`);
  },
  GetPostedStockTransaction(context, data) {
    return PropertyAPI.get(`StockItemTransaction/Posted/${data}`);
  },
  GetDraftStockTransactionByDu(context, data) {
    return PropertyAPI.get(`StockItemTransaction/Draft/DeliveryUnit/${data}`);
  },
  GetPendingStockTransactionByDu(context, data) {
    return PropertyAPI.get(`StockItemTransaction/Pending/DeliveryUnit/${data}`);
  },
  GetApprovedStockTransactionByDu(context, data) {
    return PropertyAPI.get(`StockItemTransaction/Approved/DeliveryUnit/${data}`);
  },
  GetSingleStockTransaction(context, data) {
    return PropertyAPI.get(`StockItemTransaction/${data}`);
  },
  UpdateStockTransaction(context, data) {
    return PropertyAPI.put(`StockItemTransaction/${data.id}`, data);
  },
  DeleteStockTransaction(context, data) {
    return PropertyAPI.delete(`StockItemTransaction/${data}`);
  },
  CreateStockTransaction(context, data) {
    return PropertyAPI.post(`StockItemTransaction/Create`, data);
  },
  CreateMultipleStockTransaction(context, data) {
    return PropertyAPI.post(`StockItemTransaction/Create/Multiple`, data);
  },
  PostStockTransaction(context, data) {
    return PropertyAPI.put(`StockItemTransaction/Post/${data}`);
  },
  ApproveStockTransaction(context, data) {
    return PropertyAPI.put(`StockItemTransaction/Approve/${data}`);
  },
  GenerateStockTransactionRISNumber(context, data) {
    return PropertyAPI.get(`StockItemTransaction/ReferenceNumber/${data.campusId}/${data.cycle}`);
  },

  // Inventory Stock Items
  GetInventoryStockItems(context, data) {
    return PropertyAPI.get(`InventoryStockItem/Inventory/${data}`);
  },
  CreateInventoryStockItem(context, data) {
    return PropertyAPI.post(`InventoryStockItem/Add`, data);
  },
  UpdateInventoryStockItem(context, data) {
    return PropertyAPI.put(`InventoryStockItem/${data.id}`, data);
  },
  RemoveInventoryStockItem(context, data) {
    return PropertyAPI.delete(`InventoryStockItem/Multiple`, { data });
  },
  GetSingleInventoryStockItem(context, data) {
    return PropertyAPI.get(`InventoryStockItem/${data}`);
  }
};
